export const MILLISECONDS_IN_MIN = 60_000;
